/**
 * Cloudflare Turnstile, loaded once per document.
 *
 * Lifted out of `components/search/AiSearch.jsx`, which had the only copy, when
 * the voice channel became the second caller. Two script injectors racing for
 * the same global is the kind of duplication that works until both mount at
 * once.
 *
 * `TURNSTILE_SITE_KEY` being undefined is a supported state, not a
 * misconfiguration to assert on: it means no challenge can be drawn, and every
 * caller is expected to check it before promising the user a puzzle they could
 * then not solve.
 */
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";

let scriptPromise = null;

export function loadTurnstileScript() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error("Failed to load Turnstile script"));
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}
